import React from 'react';
import storiesBg from '../../../assets/site/bg-stories.jpg';
import Section from '../../site/components/Section';
import SectionHead from '../../site/components/SectionHead';
import { testimonials } from '../../site/data/content';
import cx from '../../site/utils/cx';
import ui from '../../site/styles/primitives.module.css';
import styles from './ClientStories.module.css';

const ClientStories = () => (
  <Section id="stories" background={storiesBg} backgroundPosition="center 48%">
    <div className={ui.wrap}>
      <SectionHead eyebrow="Client stories" title="Investors who" highlight="built with us" />
      <div className={styles.grid}>
        {testimonials.map((story, index) => (
          <figure
            key={story.name}
            className={cx(styles.story, index % 2 === 0 ? ui.matte : ui.glass)}
            data-tilt=""
            data-reveal=""
          >
            <span className={styles.mark} aria-hidden="true">
              “
            </span>
            <blockquote className={styles.quote}>“{story.quote}”</blockquote>
            <figcaption className={styles.who}>
              <img className={styles.avatar} src={story.avatar} alt="" loading="lazy" />
              <div>
                <b>{story.name}</b>
                {story.location && <small>{story.location}</small>}
                <small className={styles.role}>{story.role}</small>
              </div>
            </figcaption>
          </figure>
        ))}
      </div>
    </div>
  </Section>
);

export default ClientStories;
